// extracted by mini-css-extract-plugin
export var drawerPaper = "_1w-0";
export var itemImage = "_1w-1";